const getDefaultState = () => {
    return {
        OnlineTransactionAccount:'',
        OnlineTransactionScheme:'',
        OnlineTransactionPlan:'',
        OnlineTransactionUserID:'',
        OnlineTransactionType:'',
        OnlineTransactionCurrency:'',
        OnlineTransactionInvestor:'',
        OnlineTransactionsJointAccounts:[],
        OnlineTransactionappId:'',
        OnlineTransactionWithdrawalReason:'',
        OnlineTransactionAlert:false,
        OnlineTransactionUsername:'',
        OnlineTransactionEmail:'',
        OnlineTransactionIaccessUserID:'',
        TransactionApplicationID:'',
        fundUnitConfirm:[],
        TransactionDateTime:'',
        TransactionCart:[],
        inComingTransaction:'landingpage',
        showButton: false,
        showButton2:false,
        showAgent:false,
        transactionID:'',
        referenceid:'',
        IncomingEMISFUND:'',
        ApplicationFormId:'',
        AgentDetails : [],
        AgentDetails_onboard:'',
        showOtherEPFScheme: false,
        SelectedAgent:'',
        Investment:[],
        Redemption:[],
        Switching:[],
        IsQualifiedInvestor:false,
        Transaction:{
            TotalInvestment : 0,
            //2500,
            Investment : [

               /* {
                    Id : 1001,
                    SchemeName : "Affin Hwang Select Opportunity Fund",
                    Scheme : "SOF",
                    Amount : 1000.00,
                    SalesCharge : 0
                },
                {
                    Id : 1001,
                    SchemeName : "Affin Hwang Select Dividend Fund",
                    Scheme : "SDF",
                    Amount : 1500.00,
                    SalesCharge : 0
                },*/
            ],
            tempInvestment: [],
            TotalRedemption : 0,
            minSwitching:0,
            minRedemption:0,
            minAccountBalance:0,
            Redemption : [
               /* {
                    Id: 1001,
                    AmountOrUnit: "Amount",
                    Amount: 1000,
                    Units: 200,
                    Scheme: "PRSG",
                    SchemeName: "Affin Hwang PRS Growth Fund"
                },
                {
                    Id: 1002,
                    AmountOrUnit: "Amount",
                    Amount: 700,
                    Units: 200,
                    Scheme: "PRSM",
                    SchemeName: "Affin Hwang PRS Moderate Fund"
                }*/
            ],
            AvailableSwitching:0,
            TotalSwitching : 0,
            Switching : [
                /*{
                    Id: 1001,
                    UnitsOrPercentage: "Units",
                    Units: 800,
                    Percentage: 0,
                    SalesCharge: 0,
                    FromScheme: "SOF",
                    FromSchemeName: "Affin Hwang Select Opportunity Fund",
                    ToScheme: "BOND",
                    ToSchemeName: "Affin Hwang Select Bond Fund"
                },
                {
                    Id: 1002,
                    UnitsOrPercentage: "Units",
                    Units: 1200,
                    Percentage: 0,
                    SalesCharge: 0,
                    FromScheme: "SDF",
                    FromSchemeName: "Affin Hwang Select Dividend Fund",
                    ToScheme: "ASI",
                    ToSchemeName: "Affin Hwang Select Income Fund"
                }*/
            ]
        }
       
    }
}
const state = getDefaultState()

const getters = {
    
}
const actions = {}

// mutations
const mutations = {
    ResetTransactionDetails (state) {
        Object.assign(state, getDefaultState())
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}